import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { RegistroObservacionesBitacoraDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class RegistroObservacionesBitacoraService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getRegistroObservacionesBitacoraService(): Observable<BodyListResponse<RegistroObservacionesBitacoraDTO>> {
    return this.http.get<BodyListResponse<RegistroObservacionesBitacoraDTO>>(API_URL + '/api/v1/registroObservacionesBitacora/todos');
  }

  guardarRegistroObservacionesBitacoraService(registroObservacionesBitacoraDTO: RegistroObservacionesBitacoraDTO): Observable<BodyResponse<RegistroObservacionesBitacoraDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/registroObservacionesBitacora', registroObservacionesBitacoraDTO);
  }

  getRegistroObservacionesBitacoraPorCodigoService(codigo: string): Observable<BodyResponse<RegistroObservacionesBitacoraDTO>> {
    return this.http.get<BodyResponse<RegistroObservacionesBitacoraDTO>>(API_URL + '/api/v1/registroObservacionesBitacora/' + codigo);
  }
  /**** */

  getRegistroObservacionesBitacoraPorBitacoraService(codigo: string): Observable<BodyListResponse<RegistroObservacionesBitacoraDTO>> {
    return this.http.get<BodyListResponse<RegistroObservacionesBitacoraDTO>>(API_URL + '/api/v1/registroObservacionesBitacora/bitacora/' + codigo);
  }

}
